
/* IMPORTAÇÕES */

import Template         from './modules/Template.js';
import AnimateTemplate  from './modules/AnimateOnScroll.js';
import Parallax         from './modules/Parallax.js';
import Home             from './pages/Home.js';

/* INSTANCIA CLASSES */

const template          = new Template;
const AnimateOnScroll   = new AnimateTemplate;
const parallax          = new Parallax;
const home              = new Home;

/* RUN EVENTOS HABILITANDO JQUERY */

$(function()
{
    template.init();
    AnimateOnScroll.init();
    parallax.init();
    
    home.init();

    window.onload = function()
    {   
    }();
});